import { AttributeCommunity } from './attributecommunity';

export class ChangeOrderPlanOptionAttribute {
    public id: number;
    public jobChangeOrderPlanOptionId: number;
    public attributeGroupCommunityId: number;
    public attributeCommunityId: number;
    public attributeGroupCommunity: AttributeCommunity;
    public attributeName: string;
    public attributeGroupLabel: string;
    public manufacturer: string;
    public sku: string;
    public action: string;
    public createdBy: string;
    public createdUtcDate: string;
    public lastModifiedBy: string;
    public lastModifiedUtcDate: string;
}